// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defaultLinkClick = (data: any) => {
  let domain = '';
  let path = '';
  let fullUrl = '';

  try {
    // Check if data.url is a full URL or a relative path
    if (data.url.startsWith('http') || data.url.startsWith('//')) {
      // It's already a full URL, so we can use it directly
      const urlObj = new URL(data.url);
      domain = urlObj.hostname.replace('www.', '');
      path = urlObj.pathname;
      fullUrl = data.url; // Use the original full URL as it is
    } else {
      // Handle relative pathing for URLs on the same domain
      const currentDomain = window.location.origin;
      const fullPath = new URL(data.url, currentDomain).href; // Resolves relative URL
      const urlObj = new URL(fullPath);
      domain = urlObj.hostname.replace('www.', '');
      path = urlObj.pathname;
      fullUrl = fullPath; // Now we have the full URL with the current domain
    }
  } catch (e) {
    // If something fails, fallback to the provided URL
    fullUrl = data.url;
    path = data.url;
  }

  return {
    event: 'defaultLinkClick',
    timestamp: Math.floor(Date.now() / 1000),
    link: {
      url: fullUrl,
      domain,
      path,
      innerText: data?.innerText?.trimStart(),
      position: data?.position,
      name: data?.name?.trimStart() || data?.innerText?.trimStart(),
      type: data?.type,
      socialMedia: data?.socialMedia?.trimStart(),
      socialInteraction: data?.socialInteraction,
    },
    components: {
      bookmark: {
        items: [],
      },
    },
  };
};
